import React, { } from 'react';
import {
  Container, Grid,
} from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';
import Images from '../../../../Configs/images';
import ROUTES from '../../../../Configs/routes';

export default function ResetPassConfirmation({ classes }) {
  // const navigate = useNavigate();
  const { state } = useLocation();
  return (
    <div className={classes.root}>
      <Grid container spacing={0} justifyContent="center">
        <Grid item xs={12} sm={10} md={6} lg={4}>
          <Container sx={{ py: 5, minHeight: '100vh', position: 'relative' }} maxWidth="sm">
            {/* <IconButton onClick={() => navigate(-1)}>
              <ArrowBackRounded />
            </IconButton> */}
            <div className="center">
              <h1>
                <img src={Images.Logo} alt="Boxpack" height={65} />
              </h1>
              <img src={Images.Inbox} alt="Inbox" className="mt-5" />
              <h3 className="mt-6 s-16">Email confirmation</h3>

              <div className="height-14 mt-1 desc center s-14">
                We sent a reset password link to
                <br />
                <div className="weight-600">{state?.email}</div>
              </div>
            </div>

            <div className="center mt-5">
              <div className="height-14 weight-600">
                Didn&apos;t receive email?
                {' '}
                <Link to={ROUTES.forgotPassword()} className="link primary-green weight-700">Resend</Link>
              </div>
            </div>

            {/* <div className="action">
              <Container sx={{ pb: 4 }}>

                <div className="center">
                  <div className="height-14">
                    Didn&apos;t recieve email? Check your spam filter
                    <br />
                    or
                    {' '}
                    <Link
                    className="black link weight-700"
                    to={ROUTES.forgotPassword()}>
                    Try another email address</Link>
                  </div>
                </div>
              </Container>
            </div> */}

            <div className="center mt-4 align-items-center flex-center flex">
              <ArrowBack fontSize="small" />
              <Link to={ROUTES.signin()} className="s-14 link black weight-600">Back to Sign in</Link>
            </div>

          </Container>
        </Grid>
      </Grid>
    </div>
  );
}
